import { Children, useEffect, useState } from "react";

import AddHomeWorkIcon from "@mui/icons-material/AddHomeWork";
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';

import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { ModalDeleteCore, TableCore, TdCore } from "src/Pages/components";
import { UseVerifyIsPermissionsUser } from "src/Pages/components/hooks/UseVerifyIsPermissionsUser";
import {
  DeleteForeverIcon,
  FolderCopyIcon,
  FolderOffIcon,
  CheckIcon,
  CloseIcon,
  EditIcon,
} from "src/Pages/components/Icons/Icons";

import { UseDelete } from "src/Pages/components/ModalDeleteCore/Hooks/UseDelete";
import { TableRowCore } from "src/Pages/components/table/@Core/TableRowCore/TableRowCore";
import { ActionPopoverTable } from "src/Pages/components/table/ActionPopover/ActionPopover";
import { valuesPermissions } from "src/shared/Utils/ValuesPermissions";

import { useHttpTableOperadora } from "./Hooks/useHttpTableOperadora";
import { THeadOperadora } from "./THead";
import { ModalOperadora } from "../Form";
import { ModalChangeIsActiveOperadora } from "../ChangeIsActiveProducer/ModalChangeIsActiveOperadora";

export const TableOperadora = () => {
  const { listOperadora, setValuesInputsOperadora } = useContextComissoes();
  const { handleVerifyPermissionItem } = UseVerifyIsPermissionsUser();
  const { handleGet } = useHttpTableOperadora();

  const {
    setNameSearch,
    itensPerPage,
    currentPage,
    nameSearch,
    attTable,
    setId,
  } = useConfigPageContext();

  const [openModalOperadora, setOpenModalOperadora] = useState(false);
  const [openModalActiveOperadora, setOpenModalActiveOperadora] =
    useState(false);
  const [valueActiveOperadora, setValueActiveOperadora] =
    useState<boolean>(true);

  const handleGetIdToEdit = (id: string, operadora: string) => {
    setId(id);
    setOpenModalOperadora(true);
    setValuesInputsOperadora({ name: operadora });
  };

  useEffect(() => {
    handleGet({ itensPerPage, currentPage, nameSearch });
  }, [attTable, itensPerPage, currentPage, nameSearch]);

  const {
    handleDelete,
    open: openModalDelete,
    loading: loadingDelete,
    setId: setIdModalDelete,
    setOpen: setOpenModalDelete,
  } = UseDelete({ url: "/comissoes/operadora" });

  return (
    <TableCore
      Modals={
        <>
          <ModalDeleteCore
            loading={loadingDelete}
            modalOpen={openModalDelete}
            no="Não, Cancelar"
            titlePrimary="Você deseja excluir da lista ?"
            yes="Sim, Deletar !"
            onClickFalse={() => setOpenModalDelete(false)}
            onClickTrue={() => handleDelete()}
          />
          <ModalChangeIsActiveOperadora
            isActiveOperadora={valueActiveOperadora}
            modalIsActiveOperadora={openModalActiveOperadora}
            setModalIsActiveOperadora={setOpenModalActiveOperadora}
          />
        </>
      }
      THead={<THeadOperadora />}
      qtdList={listOperadora.length}
      setNameSearch={setNameSearch}
      cardAdd={{
        title: "Operadoras",
        icon: <BusinessCenterIcon color="primary" />,
        buttonAdd: [
          <ModalOperadora
            key={1}
            openModal={openModalOperadora}
            setOpenModal={setOpenModalOperadora}
          />,
        ],
      }}
    >
      {Children.toArray(
        listOperadora.map((item) => {
          return (
            <TableRowCore id={String(item.code)}>
              <TdCore
                values={
                  <ActionPopoverTable
                    optionsList={[
                      {
                        icon: <EditIcon fontSize="small" />,
                        title: "Editar",
                        background: "warning",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.OPERADORA.EDITAR.id
                        ),
                        onClick: () =>
                          handleGetIdToEdit(String(item.code), item.name),
                      },
                      {
                        icon: item.is_active ? (
                          <FolderOffIcon fontSize="small" />
                        ) : (
                          <FolderCopyIcon fontSize="small" />
                        ),
                        background: "warning",
                        title: item.is_active ? "Desativar" : "Ativar",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.OPERADORA.EDITAR.id
                        ),
                        onClick: () => {
                          setId(item.name);
                          setOpenModalActiveOperadora(true);
                          setValueActiveOperadora(!item.is_active);
                        },
                      },
                      {
                        icon: <DeleteForeverIcon fontSize="small" />,
                        title: "Excluir",
                        background: "error",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.OPERADORA.DELETAR.id
                        ),
                        onClick: () => {
                          setIdModalDelete(item.code);
                          setOpenModalDelete(true);
                        },
                      },
                    ]}
                  />
                }
              />
              <TdCore values={`${item.code} - ${item.name}`} />

              <TdCore
                textAlign="center"
                values={
                  item.is_active ? (
                    <CheckIcon color="success" />
                  ) : (
                    <CloseIcon color="error" />
                  )
                }
              />
            </TableRowCore>
          );
        })
      )}
    </TableCore>
  );
};
